// src/App.js
import React from "react";
import { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setIsMobile,
  setIsTouchScreen,
  setScreenWidth,
} from "./reduxStore/screenSlice";
import { Routes, Route, Link } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SmarthomePage from "./pages/SmarthomePage";
import SmartbuildingPage from "./pages/SmartbuildingPage";
import LanguageBridgeWithWordpress from "./pages/LanguageBridgeWithWordpress";
import "./css/main.css";
import "./css/smarthome.css";
import "./css/smartbuilding.css";

function App() {
  const navStyle = {
    marginBottom: "20px",
  };

  const linkStyle = {
    marginRight: "10px",
    color: "#005bbb",
    textDecoration: "none",
    fontWeight: "bold",
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const update = () => {
      const width = window.innerWidth;
      dispatch(setScreenWidth(width));
      dispatch(setIsMobile(width <= 1000));
    };

    update(); // init

    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);

    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, [dispatch]);

  useEffect(() => {
    const mqHover = window.matchMedia("(hover: none)");
    const handleChange = () => {
      dispatch(setIsTouchScreen(mqHover.matches));
    };
    handleChange(); // init au mount
    mqHover.addEventListener("change", handleChange);

    return () => {
      mqHover.removeEventListener("change", handleChange);
    };
  }, [dispatch]);

  return (
    <div className="page">
      {/* Petite navigation globale (optionnelle, utile même dans Divi) */}
      {/* <nav style={navStyle}>
        <Link to="/" style={linkStyle}>
          Accueil
        </Link>
        <Link to="/smarthome" style={linkStyle}>
          Smarthome
        </Link>
        <Link to="/smartbuilding" style={linkStyle}>
          Smartbuiding
        </Link>
      </nav> */}
      <LanguageBridgeWithWordpress />
      <Routes>
        <Route path="" element={<HomePage />} />
        <Route path="smarthome" element={<SmarthomePage />} />
        <Route path="smartbuilding" element={<SmartbuildingPage />} />
      </Routes>
    </div>
  );
}

export default App;
